import { DebugRegistry } from '../DebugRegistry';
import type { System } from '../ServiceLocator';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    __twin?: unknown;
  }
}

/**
 * Owns the registry of debug snapshots that gets exposed as window.__twin
 * for end-to-end tests. Systems contribute snapshots via the registry;
 * DiagnosticsSystem.install() builds the final shape and assigns it to
 * window.
 *
 * Migration target: every System should call
 *   diagnostics.registry.registerSnapshot('foo', () => ({ ... }))
 * instead of the giant inline object literal currently in Game.run().
 */
export class DiagnosticsSystem implements System {
  readonly name = 'DiagnosticsSystem';

  readonly registry = new DebugRegistry();

  /** Merge an externally-built object (for legacy fields that haven't
   *  yet migrated to per-system registration) with the registry-built
   *  snapshot, then install on window.__twin. */
  install(legacy: Record<string, unknown> = {}): void {
    window.__twin = this.registry.installOn(legacy);
  }
}
